import React from 'react';
import {
  FiHome,
  FiAlertTriangle,
  FiUsers,
  FiPaperclip,
  FiLink,
  FiSearch,
} from 'react-icons/fi';

import { Container, NavLink } from './styles';
import { useAuth } from '../../../../hooks/auth';

const Navigation: React.FC = () => {
  const { user } = useAuth();
  const isSyndicateUser = user?.role === 'syndicate';
  return (
    <Container>
      <NavLink to="/dashboard">
        <FiHome size={24} />
        Painel
      </NavLink>
      <NavLink to="/workers">
        <FiUsers size={24} />
        Trabalhadores
      </NavLink>
      <NavLink to="/complaints">
        <FiAlertTriangle size={24} />
        Denúncias
      </NavLink>

      {!isSyndicateUser && (
        <NavLink to="/news">
          <FiPaperclip size={24} />
          Notícias
        </NavLink>
      )}

      <NavLink to="/partners">
        <FiLink size={24} />
        Convênios
      </NavLink>

      <NavLink to="/research">
        <FiSearch size={24} />
        Pesquisa
      </NavLink>
    </Container>
  );
};

export default Navigation;
